export const MenuButton = () => {
  return (
    <button
      data-bs-toggle="collapse"
      className="navbar-toggler"
      data-bs-target="#navcol-3"
    >
      <span className="visually-hidden">Toggle navigation</span>
      <span className="navbar-toggler-icon text-center pt-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          fill="currentColor"
          viewBox="0 0 16 16"
          className="bi bi-list"
        >
          <path
            fillRule="evenodd"
            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
          ></path>
        </svg>
      </span>
    </button>
  );
};

export const LinkButton = ({ classname, link, text, target }) => {
  if (target === "blank") {
    return (
      <a
        className={classname}
        role="button"
        href={link}
        target="_blank"
        rel="noreferrer noopener"
      >
        {text}
      </a>
    );
  } else {
    return (
      <a className={classname} role="button" href={link}>
        {text}
      </a>
    );
  }
};

export const ClassicButton = ({ text, classname }) => {
  return (
    <button className={classname} type="button">
      {text}
    </button>
  );
};

export const GradientButton = ({ text, onClick }) => {
  return (
    <button className="btn mint clicked" type="button" onClick={onClick}>
      {text.toLowerCase()}
    </button>
  );
};

export default MenuButton;
